module.exports = __webpack_public_path__ + "img/1488511803.1583721b.jpg";